import { render, staticRenderFns } from "./Browse.vue?vue&type=template&id=4a577a64&scoped=true&"
import script from "./Browse.vue?vue&type=script&lang=js&"
export * from "./Browse.vue?vue&type=script&lang=js&"
import style0 from "./Browse.vue?vue&type=style&index=0&id=4a577a64&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a577a64",
  null
  
)

export default component.exports